import { createTheme } from '@mui/material';

export const Dark = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#435C4A',
            contrastText: '#FFFFFF'
        },
        background: {
            default: '#121212',
            paper: '#1E1E1E'
        }
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    background: '#121212'
                }
            }
        }
    }
});
